import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { sevenHIllsRoundImg } from '../../ui/assets/images/images';
import Barcode from 'react-barcode';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import { phoneIcon, mailIcon, mapIcon, downloadIcon, printerIcon, threeDotIcon, mailIconwhite, mapIconWhite, phoneIconWhite, signIcon, rollbackIcon, shareIcon } from '../../ui/assets/svgIcons/icon';

import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import { fetchSharedReport } from '@custom/rtk-apis/report/sharedReportPreview';
import { useTheme } from '../../ui/src/contextProviders';
import { _reportStatus } from '@custom/Utils/constants/appConstants';
import { calculateAge, formatDate } from '@custom/Utils/utils';

const SharedReport = () => {
  const { id } = useParams();
  const isDarkMode = useTheme();
  const [reportDet, setReportDet] = useState([]);

  const dispatch = useDispatch<AppDispatch>();

  const { status, result, msg, loading, error } = useSelector((state: RootState) => state.getSharedReportSlice);

  useEffect(() => {
    const fetchData = async () => {
      const response = await dispatch(fetchSharedReport(id));
      setReportDet(response?.payload?.result);
    };
    fetchData();
  }, [dispatch, id]);




  // helpers
  const disableInputs = (html) => {
    // Add 'disabled' attribute to all input fields
    return html
      ?.replace(/<input/g, '<input disabled')
      ?.replace(/<textarea/g, '<textarea disabled')
      ?.replace(/<select/g, '<select disabled');
  };

  const printRef = useRef();

  // States
  const [showMenu, setShowMenu] = useState(false);

  const printAsPdf = (action = "Print") => {
    const content = printRef.current;

    html2canvas(content, {
      scale: 2,
      useCORS: true,
    }).then((canvas) => {
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      if (action === "Print") {
        const pdfUrl = pdf.output("bloburl");
        window.open(pdfUrl);
        pdf.autoPrint();
      } else {
        pdf.save("download.pdf");
      }
    });
  };


  const handleShare = () => {
    const content = printRef.current;

    html2canvas(content).then((canvas) => {
      canvas.toBlob((blob) => {
        const imageUrl = URL.createObjectURL(blob);
        shareOnMail(imageUrl);
      });
    });
  };



  const shareOnMail = (imageUrl) => {
    const subject = encodeURIComponent("Check out this image");
    const body = encodeURIComponent(`Here is the image: ${imageUrl}`);
    const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
    window.open(mailtoUrl, '_blank');
  };

  const containerStyle = {
    width: "95.7%",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  };

  const h2Style = {
    flexGrow: 1,
    textAlign: 'center',
    fontSize: '1.875rem', // This is for 3xl size
    fontWeight: '600',
  };

  // Function to dynamically set button color based on priority
  const getPriorityStyle = (priority) => {
    switch (priority) {
      case 'Routine':
        return { border: '1px solid #28a745', color: '#28a745' }; // Green
      case 'Urgent':
        return { border: '1px solid #007bff', color: '#007bff' }; // Blue
      case 'Critical':
        return { border: '1px solid #FF5C5C', color: '#FF5C5C' }; // Red
      default:
        return { border: '1px solid #ccc', color: '#ccc' }; // Default grey if no priority
    }
  };

  const buttonStyle = {
    backgroundColor: 'transparent',
    padding: '5px 15px',
    borderRadius: '4px',
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    ...getPriorityStyle(reportDet?.priority), // Merging dynamic styles
  };

  const dotStyle = {
    height: '8px',
    width: '8px',
    backgroundColor: buttonStyle.color,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '8px',
  };
  return (
    <>
    <div>
        <section className='bg-white flex bg items-center justify-between px-4 mt-4' style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className='flex flex-row items-center gap-2'>
            <button onClick={() => printAsPdf("Download")} className="bg-green-500 text-black px-2 py-1 rounded border border-black flex gap-2 items-center text-[14px] font-semibold">
              <img src={downloadIcon} />
              Download
            </button>
            <button onClick={() => printAsPdf("Print")} className="bg-green-500 text-black px-2 py-1 rounded border border-black flex gap-2 items-center text-[14px] font-semibold">
              <img src={printerIcon} />
              Print
            </button>
          </div>
        </section>
        <div ref={printRef} className='watermark-container2' style={{ overflowX: 'auto' }} onClick={() => setShowMenu(false)}>
          <div className="bg-white px-1 content shared-report-content" style={{ color: '#49475A' }}>

            {/* Hospital info */}
            <section className="flex flex-row p-2 shared-report-hospital">
              <div className="basic-1/3 p-4">
                <div className="h-full">
                  <div className='flex flex-row h-full w-full'>
                    <div className="block mx-auto" style={{ width: '150px' }}>
                      <img src={reportDet?.hospitalDetail?.hospitalLogo ? reportDet?.hospitalDetail?.hospitalLogo : sevenHIllsRoundImg} alt="" className='block mx-auto' style={isDarkMode?.isDarkMode ? { filter: "invert(1)" } : null} />
                    </div>
                    <div className='border-l-2 border-[#51A196] ml-4 h-full'></div>
                  </div>
                </div>
              </div>
              <div className="basic-2/3 p-4 w-full ml-4">
                <div>
                  <p className='text-[#51A196] text-[18px]  font-semibold'>{reportDet?.hospitalDetail?.hospitalHeader?.hospitalName ? reportDet?.hospitalDetail?.hospitalHeader?.hospitalName : reportDet?.hospitalDetail?.hospitalName}</p>
                  {/* <p className='text-[16px] font-semibold'>Dr. Oshein Orlando</p>
                  <p className='text-[14px] text-[#49475A]'>Board Certified Cardiologist & Surgeon</p> */}
                </div>

                <div className='flex flex-row gap-4 border-t-2 border-[#51A196] pt-2 mt-2 shared-report-contact-details'>
                  <div className='flex flex-row gap-2 flex-wrap'>
                    <img src={phoneIcon} alt="" />
                    <p className='text-[14px] font-normal color-[#535353]'>{reportDet?.hospitalDetail?.hospitalHeader?.contactNumberCountryCode ? reportDet?.hospitalDetail?.hospitalHeader?.contactNumberCountryCode : reportDet?.hospitalDetail?.contactNumberCountryCode} {reportDet?.hospitalDetail?.hospitalHeader?.contactNumber ? reportDet?.hospitalDetail?.hospitalHeader?.contactNumber : reportDet?.hospitalDetail?.contactNumber}</p>
                  </div>
                  <div className='flex flex-row gap-2 flex-wrap'>
                    <img src={mailIcon} alt="" />
                    <p className='text-[14px] font-normal color-[#535353]'>{reportDet?.hospitalDetail?.hospitalHeader?.email ? reportDet?.hospitalDetail?.hospitalHeader?.email : reportDet?.hospitalDetail?.hospitalEmailId}</p>
                  </div>
                  <div className='flex flex-row gap-2 flex-wrap'>
                    <img src={mapIcon} alt="" />
                    <p className='text-[14px] font-normal color-[#535353]'>{reportDet?.hospitalDetail?.hospitalHeader?.address ? reportDet?.hospitalDetail?.hospitalHeader?.address : reportDet?.hospitalDetail?.address} </p>
                  </div>
                </div>

              </div>
            </section>

            <section className='bg-[#51A196] p-2'>
              <p className='text-[17.53px] font-semibold text-white text-center'>Report</p>
            </section>
            <section className='px-2 py-4'>
              <p className='text-[24px] font-semibold mb-4 text-[#49475A]'>{reportDet?.name || '---'}</p>
              <div className="grid grid-cols-2 gap-x-4 shared-report-patient" style={{ rowGap: '14px' }}>
                <p className='col-span-2 text-[14px]'><span className='font-semibold text-[#49475A]'>Patient ID: </span>{reportDet?.patientId || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Date: </span>{reportDet?.date ? formatDate(reportDet.date) : '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Gender: </span>{reportDet?.gender || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Age: </span>{reportDet?.age ? calculateAge(reportDet.age) || '---' : '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Blood Group: </span>{reportDet?.patientDetail?.bloodGroup || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Phone Number: </span>{reportDet?.patientDetail?.contactInfo?.mobileNo || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>WhatsApp Number: </span>{reportDet?.patientDetail?.contactInfo?.whatsappNo || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Height: </span>{reportDet?.patientDetail?.height || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Weight: </span>{reportDet?.patientDetail?.weight || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Consulting Doctor: </span>{reportDet?.patientDetail?.referPhysicianInfo?.name || '---'}</p>
                <p className='text-[14px]'><span className='font-semibold text-[#49475A]'>Modality Type: </span>{reportDet?.modality || '---'}</p>
                <div className="col-span-2 flex items-center justify-between gap-4 text-[14px]">
                  <p><span className='font-semibold text-[#49475A]'>UHID: </span>{reportDet?.uhid || '---'}</p>
                  {reportDet?.uhid && <Barcode displayValue={false} width={1.2} height={50} value={reportDet.uhid} />}
                </div>
              </div>
            </section>
            <div style={containerStyle}>
              <h2 style={h2Style}>{reportDet?.reportName || '---'}</h2>
              {reportDet?.priority && (
                <button style={buttonStyle}>
                  <span style={dotStyle}></span>
                  {reportDet.priority}
                </button>
              )}
            </div>
            <h3 className="text-xl font-semibold mb-2 font-sans">Findings</h3>
            <section
              id="html-render"
              className='mb-4'
              style={{ pointerEvents: 'none', userSelect: 'none' }}
              dangerouslySetInnerHTML={{ __html: disableInputs(reportDet?.templateHTML) || '' }}>
            </section>

            {reportDet?.addendum && (
              <section className="mb-4">
                <h3 className="text-xl font-semibold mb-2 font-sans">Addendum</h3>
                <textarea className="w-full p-2 border border-gray-400 rounded bg-transparent text-black" disabled rows={4} value={reportDet.addendum} />
              </section>
            )}

            {reportDet?.impressions && (
              <section className="mb-4">
                <h3 className="text-xl font-semibold mb-2 font-sans">Impression</h3>
                <textarea className="w-full p-2 border border-gray-400 rounded bg-transparent text-black" disabled rows={4} value={reportDet.impressions} />
              </section>
            )}

            {reportDet?.status === _reportStatus.Authorized && (
              <section className="mb-4 border-b-2 border-[#49475A] pt-2">
                {reportDet?.signatureDetail?.signature && (
                  <img src={reportDet.signatureDetail.signature} alt="Authorized signature" style={{ width: '150px', height: '100px' }} />
                )}
                <p className="text-[22px] font-semibold">{reportDet?.authorizedUserName || ''}</p>
                {reportDet?.authorizedUserRole && <p className="text-[16px] font-normal mb-1">{reportDet.authorizedUserRole}</p>}
                {reportDet?.authorizedOn && <p className="text-[16px] font-normal mb-1">Authorized On - {formatDate(reportDet.authorizedOn, 'withTime')}</p>}
                <p className="text-[16px] font-normal">This is a system generated report. Personal signature may not be required.</p>
              </section>
            )}

            <div className='bg-[#51A196] pt-2 pb-2 pr-2 pl-2 shared-report-footer'>
              <div className='flex flex-row gap-4 justify-between items-center border-t-2 border-[#51A196]'>
                <div className='flex flex-row gap-2 flex-wrap'>
                  <img src={phoneIconWhite} alt="" />
                  <p className='text-[14px] font-normal text-white'>{reportDet?.hospitalDetail?.hospitalFooter?.contactNumberCountryCode ? reportDet?.hospitalDetail?.hospitalFooter?.contactNumberCountryCode : reportDet?.hospitalDetail?.contactNumberCountryCode} {reportDet?.hospitalDetail?.hospitalFooter?.contactNumber ? reportDet?.hospitalDetail?.hospitalFooter?.contactNumber : reportDet?.hospitalDetail?.contactNumber}</p>
                </div>
                <div className='flex flex-row gap-2 flex-wrap'>
                  <img src={mailIconwhite} alt="" />
                  <p className='text-[14px] font-normal text-white'>{reportDet?.hospitalDetail?.hospitalFooter?.email ? reportDet?.hospitalDetail?.hospitalFooter?.email : reportDet?.hospitalDetail?.hospitalEmailId}</p>
                </div>
                <div className='flex flex-row gap-2 flex-wrap'>
                  <img src={mapIconWhite} alt="" />
                  <p className='text-[14px] font-normal text-white'>{reportDet?.hospitalDetail?.hospitalFooter?.address ? reportDet?.hospitalDetail?.hospitalFooter?.address : reportDet?.hospitalDetail?.address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SharedReport;
